<agpr-take-over-panel
    class="takeover"
    [id]="id"
    header="FallbackPersonalizationDialog.heading"
    [showTopPadding]="false"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="closeDialog()"
    [width]="50"
>
    <div class="content">
        <div class="list-header">
            <div class="list-headerCell list-headerCell-first">
                <h3> {{ 'MergeTagsEditDialog.columnHeading.name' | localize }} </h3>
            </div>
            <div class="list-headerCell">
                <h3> {{ 'MergeTagsEditDialog.columnHeading.textTag' | localize }} </h3>
            </div>
            <div class="list-headerCell">
                <h3> {{ 'MergeTagsEditDialog.columnHeading.fallback' | localize }} </h3>
                <span
                    role="img"
                    class="fa-regular fa-circle-info"
                    agprTooltip="MergeTagsEditDialog.fallback.tooltip"
                ></span>
            </div>
        </div>
        <agpr-scroll-panel class="scrollPanel">
            <div
                class="list"
                role="table"
            >
                @for (row of dataRows; track row; let i = $index) {
                    <div class="list-row">
                        <div class="list-cell">
                            <span class="list-cell-first"> {{ row.name }} </span>
                        </div>

                        <div class="list-cell">
                            <span> {{ row.textTag }} </span>
                        </div>

                        <div class="list-cell">
                            @if (row.mergeTag.key === personalizationTag.INTRO || row.mergeTag.key === personalizationTag.OUTRO) {
                                @if (row.fallbackString?.length > 0) {
                                    <div class="list-cellClamp">
                                        <agpr-shadow-dom-container
                                            [customHtml]="row.fallbackString"
                                        ></agpr-shadow-dom-container>
                                    </div>
                                } @else {
                                    <span class="list-cell-blank">
                                        {{ 'MergeTagsEditDialog.fallback.blank' | localize }}
                                    </span>
                                }

                                <agpr-button
                                    [id]="id + '_editButton'"
                                    class="button"
                                    [style]="buttonType.icon"
                                    icon="fa-regular fa-duotone fa-pen"
                                    tooltipPosition="top"
                                    [tooltip]="row.mergeTag.key === personalizationTag.INTRO ?
                                        'Discover.distribution.editPersonalizationIntro.tooltip': 'Discover.distribution.editPersonalizationOutro.tooltip'"
                                    (click)="openEditDialog(row)"
                                ></agpr-button>
                            } @else {
                                <agpr-text-input
                                    [id]="id + '_' + row.mergeTag?.key + '_fallbackCell'"
                                    placeholder="MergeTagsEditDialog.fallback.textInputPlaceholder"
                                    [bottomMargin]="false"
                                    [(ngModel)]="row.fallbackString"
                                    (ngModelChange)="fallbackTextChanged(row, $event)"
                                ></agpr-text-input>
                            }
                        </div>
                    </div>
                }
            </div>
        </agpr-scroll-panel>
    </div>

    <ng-template #takeOverFooterRight>
        <agpr-button
            label="done"
            (click)="saveFallback()"
            [style]="buttonType.primary"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
